import { render } from "./IndestryCard.vue?vue&type=template&id=cf77535c&scoped=true"
import script from "./IndestryCard.vue?vue&type=script&lang=js"
export * from "./IndestryCard.vue?vue&type=script&lang=js"

import "./IndestryCard.vue?vue&type=style&index=0&id=cf77535c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf77535c"]])

export default __exports__